import {
    allFetch
} from "../Domain";

/**
 * @description ECC
 */
export const Commodity = (() => {
    /**
     * @description 零件標籤新建
     * @param {string} label_big 第一層流水號
     * @param {string} label_mid 第二層流水號
     * @param {string} content 標籤名稱
     * @param {string} type 零件類別
     * @param {string} is_front 是否前台用
     * @param {string} is_nav 是否放在nav
     * @param {string} seq 排序
     * @returns 
     */
    const CommodityLabelCreate = async (obj) => {
        return await allFetch('Commodity/CommodityLabelCreate', obj);
    }

    /**
     * @description  零件標籤查詢
     * @param {string} label_big 第一層流水號
     * @param {string} label_mid 第二層流水號
     * @param {string} visible 是否可見
     * @param {string} type 零件類別
     * @param {string} is_front 是否前台用
     * @param {string} is_nav 是否放在nav
     * @returns 
     */
    const CommodityLabelSearch = async (obj) => {
        return await allFetch('Commodity/CommodityLabelSearch', obj);
    }

    /**
     * @description  零件標籤修改
     * @param {string} cl_id 流水號
     * @param {string} label_big 第一層流水號
     * @param {string} label_mid 第二層流水號
     * @param {string} content 標籤名稱
     * @param {string} visible 是否可見
     * @param {string} is_front 是否前台用
     * @param {string} is_nav 是否放在nav
     * @returns 
     */
    const CommodityLabelUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityLabelUpdate', obj);
    }

    /**
     * @description  零件標籤刪除
     * @param {string} cl_id 流水號
     * @returns 
     */
    const CommodityLabelDelete = async (obj) => {
        return await allFetch('Commodity/CommodityLabelDelete', obj);
    }

    /**
     * @description  零件標籤細項
     * @param {string} cl_id 流水號
     * @returns 
     */
    const CommodityLabelDetail = async (obj) => {
        return await allFetch('Commodity/CommodityLabelDetail', obj);
    }

    /**
     * @description  零件新建
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} type 零件類別
     * @param {string} label_big 大標籤
     * @param {string} label_mid 中標籤
     * @param {string} label_small 小標籤
     * @param {string} unit 單位
     * @param {string} note 備註
     * @param {string} buy_retail_price 零售買入價
     * @param {string} buy_wholesale_price 批發買入價
     * @param {string} sale_price 售價
     * @param {string} suggested_price 建議售價
     * @param {string} safe_storage 安全庫存
     * @param {string} need_calc_stock 是否需要計算庫存
     * @param {string} iscombination 是否組合零件
     * @param {string} on_shelf_time 上架時間
     * @param {string} off_shelf_time 下架時間
     * @param {string} ccam_name_1 屬性主項名稱1
     * @param {string} ccad_name_1 屬性細項名稱1
     * @param {string} ccam_name_2 屬性主項名稱2
     * @param {string} ccad_name_2 屬性細項名稱2
     * @param {string} weight 重量(公斤)
     * @param {string} introduction 零件介紹
     * @param {string} seq 排序
     * @returns 
     */
    const CommodityCreate = async (obj) => {
        return await allFetch('Commodity/CommodityCreate', obj);
    }

    /**
     * @description  零件查詢
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} type 零件類別
     * @param {string} label_big 大標籤
     * @param {string} label_mid 中標籤
     * @param {string} label_small 小標籤
     * @param {string} visible 是否可見
     * @param {string} iscombination 是否組合零件
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @param {string} excel 是否匯出
     * @returns 
     */
    const CommoditySearch = async (obj) => {
        return await allFetch('Commodity/CommoditySearch', obj);
    }

    /**
     * @description  零件修改
     * @param {string} commodity_id 零件主項流水號
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} label_big 大標籤
     * @param {string} label_mid 中標籤
     * @param {string} label_small 小標籤
     * @param {string} unit 單位
     * @param {string} note 備註
     * @param {string} visible 是否可見
     * @param {string} need_calc_stock 是否需要計算庫存
     * @param {string} iscombination 是否組合零件
     * @param {string} weight 重量(公斤)
     * @param {string} introduction 零件介紹
     * @param {string} seq 排序
     * @returns 
     */
    const CommodityUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityUpdate', obj);
    }

    /**
     * @description  零件刪除
     * @param {string} commodity_id 零件主項流水號
     * @returns 
     */
    const CommodityDelete = async (obj) => {
        return await allFetch('Commodity/CommodityDelete', obj);
    }

    /**
     * @description  零件細項
     * @param {string} commodity_id 零件主項流水號
     * @returns 
     */
    const CommodityDetail = async (obj) => {
        return await allFetch('Commodity/CommodityDetail', obj);
    }

    /**
     * @description  查詢零件上架時段
     * @param {string} commodity_id 零件主項流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const CommodityOnShelfPeriodSearch = async (obj) => {
        return await allFetch('Commodity/CommodityOnShelfPeriodSearch', obj);
    }

    /**
     * @description  零件綁車型規格查詢
     * @param {string} commodity_id 零件主項流水號
     * @param {string} ct_id 車型流水號
     * @param {string} ctf_id 車型規格流水號
     * @returns 
     */
    const CommodityXCarTypeXFormatSearch = async (obj) => {
        return await allFetch('Commodity/CommodityXCarTypeXFormatSearch', obj);
    }

    /**
     * @description  零件綁車型規格更新
     * @param {string} commodity_id 零件主項流水號
     * @param {string} cart_type_formats 車型&規格流水號列表
     * @returns 
     */
    const CommodityXCarTypeXFormatUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityXCarTypeXFormatUpdate', obj);
    }

    /**
     * @description  零件綁廠商查詢
     * @param {string} commodity_id 零件主項流水號
     * @param {string} company_id 廠商流水號列表
     * @returns 
     */
    const CommodityXCompanySearch = async (obj) => {
        return await allFetch('Commodity/CommodityXCompanySearch', obj);
    }

    /**
     * @description  零件綁廠商更新
     * @param {string} commodity_id 零件主項流水號
     * @param {string} company_id 廠商流水號列表
     * @returns 
     */
    const CommodityXCompanyUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityXCompanyUpdate', obj);
    }

    /**
     * @description  查詢零件自訂屬性主項
     * @param {string} commodity_id 零件流水號
     * @returns 
     */
    const CommodityCustomAttriMasterSearch = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriMasterSearch', obj);
    }

    /**
     * @description  修改零件自訂屬性主項
     * @param {string} ccam_id 主項流水號
     * @param {string} ccam_name 屬性主項名稱
     * @returns 
     */
    const CommodityCustomAttriMasterUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriMasterUpdate', obj);
    }

    /**
     * @description  零件自訂屬性主項細項
     * @param {string} ccam_id 主項流水號
     * @returns 
     */
    const CommodityCustomAttriMasterDetail = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriMasterDetail', obj);
    }

    /**
     * @description  新增零件自訂屬性細項
     * @param {string} ccam_id 主項流水號
     * @param {string} ccad_name 屬性細項名稱
     * @returns 
     */
    const CommodityCustomAttriDetailCreate = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriDetailCreate', obj);

    }

    /**
     * @description  查詢零件自訂屬性細項
     * @param {string} ccam_id 主項流水號
     * @returns 
     */
    const CommodityCustomAttriDetailSearch = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriDetailSearch', obj);
    }

    /**
     * @description  修改零件自訂屬性細項
     * @param {string} ccad_id 細項流水號
     * @param {string} ccad_name 屬性細項名稱
     * @returns 
     */
    const CommodityCustomAttriDetailUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriDetailUpdate', obj);
    }

    /**
     * @description  刪除零件自訂屬性細項
     * @param {string} ccad_id 細項流水號
     * @returns 
     */
    const CommodityCustomAttriDetailDelete = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriDetailDelete', obj);
    }

    /**
     * @description  查詢零件自訂屬性細項
     * @param {string} ccad_id 細項流水號
     * @returns 
     */
    const CommodityCustomAttriDetailDetail = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriDetailDetail', obj);
    }

    /**
     * @description  自訂屬性查詢(可用列表)
     * @param {string} commodity_id 細項零件流水號流水號
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} type 零件類別
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const CommodityCustomAttriList = async (obj) => {
        return await allFetch('Commodity/CommodityCustomAttriList', obj);
    }

    /**
     * @description  零件組合內容新增
     * @param {string} commodity_id 零件主項流水號
     * @param {string} ccad_id_1 自定義屬性細項流水號1
     * @param {string} ccad_id_2 自定義屬性細項流水號2
     * @param {string} contents 內容零件們
     * @returns 
     */
    const CommodityCombinationCreate = async (obj) => {
        return await allFetch('Commodity/CommodityCombinationCreate', obj);
    }

    /**
     * @description  零件組合內容修改(數量)
     * @param {string} ccd_id 流水號
     * @param {string} count 數量
     * @returns 
     */
    const CommodityCombinationUpdate = async (obj) => {
        return await allFetch('Commodity/CommodityCombinationUpdate', obj);
    }

    /**
     * @description  零件組合內容刪除
     * @param {string} ccd_id 流水號
     * @returns 
     */
    const CommodityCombinationDelete = async (obj) => {
        return await allFetch('Commodity/CommodityCombinationDelete', obj);
    }

    /**
     * @description  組合零件
     * @param {string} commodity_id 零件主項流水號
     * @param {string} uc_id 單位轉換流水號
     * @param {string} ccad_id_1 自定義屬性細項流水號1
     * @param {string} ccad_id_2 自定義屬性細項流水號2
     * @param {string} count 組合數量
     * @param {string} warehouse_id 倉庫流水號
     * @returns 
     */
    const CommodityAssemble = async (obj) => {
        return await allFetch('Commodity/CommodityAssemble', obj);
    }

    /**
     * @description  拆解零件
     * @param {string} commodity_id 零件主項流水號
     * @param {string} uc_id 單位轉換流水號
     * @param {string} ccad_id_1 自定義屬性細項流水號1
     * @param {string} ccad_id_2 自定義屬性細項流水號2
     * @param {string} count 組合數量
     * @param {string} warehouse_id 倉庫流水號
     * @returns 
     */
    const CommodityDisassemble = async (obj) => {
        return await allFetch('Commodity/CommodityDisassemble', obj);
    }

    /**
     * @description  零件匯入
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} type 零件類別
     * @param {string} label_big 大標籤名稱
     * @param {string} label_mid 中標籤名稱
     * @param {string} label_small 小標籤名稱
     * @param {string} on_shelf_time 上架時間
     * @param {string} off_shelf_time 下架時間
     * @param {string} unit 單位名稱
     * @param {string} note 備註
     * @param {string} buy_retail_price 零售買入價
     * @param {string} buy_wholesale_price 批發買入價
     * @param {string} sale_price 售價
     * @param {string} suggested_price 建議售價
     * @param {string} safe_storage 安全庫存
     * @param {string} need_calc_stock 是否需要計算庫存
     * @param {string} iscombination 是否組合零件
     * @param {string} ccam_name_1 屬性主項名稱1
     * @param {string} ccad_name_1 屬性細項名稱1
     * @param {string} ccam_name_2 屬性主項名稱2
     * @param {string} ccad_name_2 屬性細項名稱2
     * @param {string} company 廠商名稱
     * @returns 
     */
    const CommodityImport = async (obj) => {
        return await allFetch('Commodity/CommodityImport', obj);
    }

    /**
     * @description  零件列表
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} type 零件類別
     * @param {string} company_id 廠商流水號
     * @param {string} label_big 大標籤
     * @param {string} label_mid 中標籤
     * @param {string} label_small 小標籤
     * @returns 
     */
    const CommodityList = async (obj) => {
        return await allFetch('Commodity/CommodityList', obj);
    }

    /**
     * @description  零件庫存查詢
     * @param {string} commodity_id 零件主項流水號
     * @param {string} uc_id 單位換算流水號
     * @param {string} ccad_id_1 自定義屬性細項流水號1
     * @param {string} ccad_id_2 自定義屬性細項流水號2
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const CommodityStorage = async (obj) => {
        return await allFetch('Commodity/CommodityStorage', obj);
    }

    /**
     * @description  單位轉換查詢
     * @param {string} commodity_id 零件主項流水號
     * @param {string} visible 是否可見
     * @returns 
     */
    const UnitConversionSearch = async (obj) => {
        return await allFetch('Commodity/UnitConversionSearch', obj);
    }

    /**
     * @description  單位轉換修改
     * @param {string} uc_id 單位換算流水號
     * @param {string} commodity_id 零件主項流水號
     * @param {string} convert_unit_id 轉換單位流水號
     * @param {string} convert_count 轉換單位數量
     * @param {string} basic_unit_id 基本單位流水號
     * @param {string} basic_count 基本單位數量
     * @param {string} safe_storage 安全庫存
     * @param {string} visible 是否可見
     * @param {string} buy_retail_price 零售買入價
     * @param {string} buy_wholesale_price 批發買入價
     * @param {string} sale_price 售價
     * @returns 
     */
    const UnitConversionUpdate = async (obj) => {
        return await allFetch('Commodity/UnitConversionUpdate', obj);
    }

    /**
     * @description  單位轉換細項
     * @param {string} uc_id 單位換算流水號
     * @returns 
     */
    const UnitConversionDetail = async (obj) => {
        return await allFetch('Commodity/UnitConversionDetail', obj);
    }

    /**
     * @description  單位轉換列表
     * @param {string} commodity_id 零件主項流水號
     * @param {string} commodity_code 零件編號
     * @param {string} commodity_name 零件名稱
     * @param {string} type 零件類別
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const UnitConversionList = async (obj) => {
        return await allFetch('Commodity/UnitConversionList', obj);
    }

    /**
     * @description  單位查詢
     * @param {string} unit_name 單位名稱
     * @param {string} visible 是否可見
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns 
     */
    const UnitSearch = async (obj) => {
        return await allFetch('Commodity/UnitSearch', obj);
    }

    return {
        CommodityLabelCreate,
        CommodityLabelSearch,
        CommodityLabelUpdate,
        CommodityLabelDelete,
        CommodityLabelDetail,
        CommodityCreate,
        CommoditySearch,
        CommodityUpdate,
        CommodityDelete,
        CommodityDetail,
        CommodityOnShelfPeriodSearch,
        CommodityXCarTypeXFormatSearch,
        CommodityXCarTypeXFormatUpdate,
        CommodityXCompanySearch,
        CommodityXCompanyUpdate,
        CommodityCustomAttriMasterSearch,
        CommodityCustomAttriMasterUpdate,
        CommodityCustomAttriMasterDetail,
        CommodityCustomAttriDetailCreate,
        CommodityCustomAttriDetailSearch,
        CommodityCustomAttriDetailUpdate,
        CommodityCustomAttriDetailDelete,
        CommodityCustomAttriDetailDetail,
        CommodityCustomAttriList,
        CommodityCombinationCreate,
        CommodityCombinationUpdate,
        CommodityCombinationDelete,
        CommodityAssemble,
        CommodityDisassemble,
        CommodityImport,
        CommodityList,
        CommodityStorage,
        UnitConversionSearch,
        UnitConversionUpdate,
        UnitConversionDetail,
        UnitConversionList,
        UnitSearch
    }
})();